/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    declarationsDocumentsHeader: {
        id: 'declarationsDocuments.declarationsDocumentsHeader',
        defaultMessage: 'test documents'
    },
    AcceptInfo: {
        id: 'declarationsDocuments.AcceptInfo',
        defaultMessage: 'By clicking {acceptText}, you confirm that you have read the '
    },
    Following: {
        id: 'declarationsDocuments.Following',
        defaultMessage: 'following:'
    },
    ImportantInfoLink: {
        id: 'declarationsDocuments.ImportantInfoLink',
        defaultMessage: 'Important information'
    },
    IpidLink: {
        id: 'declarationsDocuments.IpidLink',
        defaultMessage: 'Insurance Product Information Document.'
    },
});
